export const getAlgoliaStockQuery = (
  indexPrefix: string,
  stopSellingQuantity: number,
) =>
  indexPrefix === 'en_gb'
    ? `(locations_inventory.18536016 > ${stopSellingQuantity}) OR (locations_inventory.18536016 < 0)`
    : `(inventory_quantity > ${stopSellingQuantity} OR inventory_quantity < 0 )`
